import OEToolbox from '../../../lib/tools/oe-toolbox';
import OETextViewAdapter from '../../views/text-view/oe-text-view-adapter';
import {OEXRayIcarusCustomPropKey, OEXRayIcarusMode, OEXRayIcarusId, OEXRayIcarusModel} from './oe-xray-icarus-model';

export default class OEXRayIcarusTextViewAdapter extends OETextViewAdapter {

    constructor(localize = true) {
        super();

        this.localize = localize;

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onCustomPropertyChanged = this.onCustomPropertyChanged.bind(this);
    }

    onConnect(oe, controller)   {
        this.updateState();
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.customPropertyChanged, this.onCustomPropertyChanged);
    }

    onRelease(oe, controller)   {
        this.updateState(true);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.customPropertyChanged, this.onCustomPropertyChanged);
    }

    updateSrc() {
        if(!this.oe || !this.oe.isReady())  return;
        const si = this.oe.sharedInterface;

        if(this.xhr)    {
            this.xhr.abort();
            delete this.xhr;
        }

        let id = si.getCustomProperty(OEXRayIcarusCustomPropKey.itemId);
        id = new OEXRayIcarusId(id.value);
        let item = OEXRayIcarusModel.shared().getResolvedItem(id);
        let mode = si.getCustomProperty(OEXRayIcarusCustomPropKey.mode).value;
        let textSrc = item ? (mode == OEXRayIcarusMode.std ? item.textSrc : (mode == OEXRayIcarusMode.xRay ? item.xRayTextSrc : undefined)) : undefined;

        if(!textSrc)  {
            this.__src = null;
            this.setSrc(null);
            return;
        }

        const prefix = 'app/oe/' + this.oe.Module.filePackagePathURL + 'xRayMedia/texts/';

        if(!this.localize)  {
            this.__src = prefix + textSrc;
            this.setSrc(this.__src);
            return;
        }

        //
        let lang = si.getUIControllerSettings().getLanguageCode();
        let locTextSrc = lang != 'EN' ? OEToolbox.addFilenamePostfix(textSrc, '_' + lang) : textSrc;

        let src = prefix + locTextSrc;
        this.__src = src;

        this.xhr = new XMLHttpRequest()
        this.xhr.open('HEAD', this.__src, true);

        this.xhr.onreadystatechange = function(e){
            if(this.xhr.readyState !== XMLHttpRequest.DONE || this.__src !== src)  return;
            if(this.xhr.status === 404) {
                this.setSrc(prefix + textSrc);
            } else {
                this.setSrc(src);
            }
            delete this.xhr;
        }.bind(this);
        this.xhr.onerror = function(e){
            if(this.__src !== src)  return;
            let src_ = prefix + textSrc;
            this.setSrc(src_);
            delete this.xhr;
        }.bind(this);

        this.xhr.send();
    }

    updateLanguage()   {
        this.updateSrc();
    }

    updateState(released)   {
        if(!this.oe || !this.oe.isReady() || released === true)   {
            this.setSrc(null);
            return;
        }

        this.updateSrc();
    }

    onCustomPropertyChanged(message, userInfo)   {
        if(userInfo.key === OEXRayIcarusCustomPropKey.mode || userInfo.key === OEXRayIcarusCustomPropKey.itemId)   {
            this.updateSrc();
        }
    }
};